<span class="info-snackbar">
  {{ data }}
</span>
